import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import * as AdminLTE from 'admin-lte';
import Swal from 'sweetalert2';
import 'select2';
import 'datatables.net-bs5';

// Import Global Helpers
import { initCascadingSelectFilter } from './cascading-select_filter';
import { initCascadingSelectFormTambah } from './cascading-select_form_tambah';
import { handleFlashMessages, initDeleteConfirm } from './utils/sweetalert';
import { initTableUtils } from './utils/table-utils';
import { initServerTable } from './utils/server-table';
import { initGlobalSelect2 } from './utils/select2-utils';
import { initButtonUtils } from './utils/button-utils';
import { initGlobalCrud } from './global-crud';
import { initChunkImport } from './utils/import-chunk';
import { initWeatherWidget } from './components/weather-widget';

// Import Admin Modules
import { initInspeksi } from './export/export-inspeksi-jtm';
import { initUsers, initUsersCreate, initUsersEdit } from './auth/users';
import { initRoles } from './auth/roles';
import { initProfile } from './pegawai/profile';
import { initMasterData } from './master-data/master-data';
import { initMenus } from './setting/menus';
import { initGroups } from './auth/groups';
import { initButtonAccess } from './setting/button-access';
import { initPegawai } from './pegawai/pegawai';
import { initPegawaiPerformance } from './pegawai/performance';
import { initTraffic } from './setting/traffic';

import { initJenisPekerjaan } from './master-data/jenis-pekerjaan';
import { initJenisGardu } from './master-data/jenis-gardu';
import { initGardu } from './master-data/mster-gardu';
import { initInspeksiJtm } from './inspeksi/inspeksi-jtm';
import { initInspeksiGardu } from './inspeksi/inspeksi-gardu';
import { initEksekusiJtm } from './eksekusi/eksekusi-jtm';
import { initEksekusiJtmApproval } from './eksekusi/eksekusi-jtm-approval';
import { initEksekusiGardu } from './eksekusi/eksekusi-gardu';
import { initRow, initRowApproval } from './eksekusi/row';
import { initPatrol } from './inspeksi/patrol';
import { initWorkOrderJtm } from './inspeksi/work-order-jtm';
import { initLogsheetDashboard } from './logsheet/dashboard';
import { initMapTiang } from './maps/map-tiang';
import { initTracking } from './tracking';
import { initTrash } from './setting/trash';
import { initMainDashboard } from './dashboard/main-dashboard';
import { initLogsheet } from './logsheet/index';

// Import Auth Modules
import { initLogin } from './auth/login';
import { initEksekusiApprovalSetting } from './setting/eksekusi-approval-setting';
import { initTargetKinerja } from './setting/target-kinerja';
import { initTiangNativeTable } from './master-data/tiang-native';
import { initChatAssistant } from './ai/chat-assistant';
import { initAiContext } from './ai/ai-context';
import { initSystemLogs } from './setting/system-logs';
import { initPerformanceMonitoring } from './monitoring/performance';
import { initRequestLogs } from './monitoring/request-logs';
import { initLaporanCallback } from './laporan-callback';

// Set Global Variables
window.$ = window.jQuery = $;
window.bootstrap = bootstrap;
window.Swal = Swal;
window.AdminLTE = AdminLTE;

$(document).ready(function () {
  console.log('[App] Core initialized');

  // 1. Initialize Global UI Components
  initGlobalSelect2();
  initGlobalTooltips();
  initCascadingSelectFilter();
  initCascadingSelectFormTambah();
  initWeatherWidget();

  // Initialize Utility Events
  handleFlashMessages();
  initTableUtils();
  initServerTable();
  initButtonUtils();
  initGlobalCrud();
  initChunkImport();
  initThemeToggle();

  // 2. Detect Page and Initialize Specific Module
  const pageIdElem = document.getElementById('page-id');
  const page = pageIdElem ? pageIdElem.dataset.page : null;

  if (page) {
    const basePage = page.replace('trash-', '');
    console.log(`[App] Initializing page module: ${page} (base: ${basePage})`);
    switch (basePage) {
      case 'inspeksi':
        initInspeksi();
        break;
      case 'users':
        initUsers();
        break;
      case 'laporan-callback':
        initLaporanCallback();
        break;
      case 'users_create':
        initUsersCreate();
        break;
      case 'users_edit':
        initUsersEdit();
        break;
      case 'roles':
        initRoles();
        break;
      case 'profile':
        initProfile();
        break;
      case 'menus':
        initMenus();
        break;
      case 'unit-induk':
      case 'jabatan':
      case 'level-jabatan':
      case 'tipe-pegawai':
      case 'up3':
      case 'ulp':
      case 'kantor-jaga':
      case 'pohon':
      case 'komponen':
      case 'kondisi':
      case 'zona':
      case 'pekerjaan':
      case 'segment':
      case 'percabangan':
      case 'tegakan':
      case 'material-vendor':
      case 'material-item':
      case 'objek-pekerjaan':
      case 'kategori-asset':
      case 'vendor':
      case 'tiang':
        initMasterData();
        initTiangNativeTable();
        break;
      case 'penyulang':
      case 'master-data':
        initMasterData();
        break;
      case 'pegawai':
        initMasterData();
        initPegawai();
        break;
      case 'pegawai_performance':
        initPegawaiPerformance();
        break;
      case 'jenis-pekerjaan':
        initMasterData();
        initJenisPekerjaan();
        break;
      case 'jenis-gardu':
        initMasterData();
        initJenisGardu();
        break;
      case 'gardu':
        initMasterData();
        initGardu();
        break;
      case 'inspeksi-jtm':
        initInspeksiJtm();
        break;
      case 'inspeksi-gardu':
        initInspeksiGardu();
        break;
      case 'eksekusi-jtm':
        initEksekusiJtm();
        break;
      case 'row':
        initMasterData();
        initRow();
        break;
      case 'row-approval':
        initRowApproval();
        break;
      case 'eksekusi-jtm-approval':
        initEksekusiJtmApproval();
        break;
      case 'eksekusi-gardu':
        initEksekusiGardu();
        break;
      case 'menus':
        initMenus();
        break;
      case 'groups':
        initGroups();
        break;
      case 'button-access':
        initButtonAccess();
        break;
      case 'traffic':
        initTraffic();
        break;
      case 'work-order-jtm':
        initWorkOrderJtm();
        break;
      case 'patrol':
        initPatrol();
        break;
      case 'map-tiang':
        initMapTiang();
        break;
      case 'tracking':
        initTracking();
        break;
      case 'login':
        initLogin();
        break;
      case 'trash':
        initTrash();
        break;
      case 'eksekusi-approval-setting':
        initEksekusiApprovalSetting();
        break;
      case 'target-kinerja':
        initServerTable();
        initTargetKinerja();
        break;
      case 'dashboard':
        initMainDashboard();
        break;
      case 'logsheet':
        initLogsheet();
        break;
      case 'logsheet-dashboard':
        initLogsheetDashboard();
        break;
      case 'chat-assistant':
        initChatAssistant();
        break;
      case 'ai-context':
        initAiContext();
        break;
      case 'system-logs':
        initSystemLogs();
        break;
      case 'performance':
        initPerformanceMonitoring();
        break;
      case 'request-logs':
        initRequestLogs();
        break;
    }
  }

  // 3. Global AJAX Setup (CSRF & Headers)
  $.ajaxSetup({
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
    beforeSend: function (xhr, settings) {
      // Send CSRF token in header for non-GET requests
      if (!/^(GET|HEAD|OPTIONS|TRACE)$/i.test(settings.type) && !this.crossDomain) {
        xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="X-CSRF-TOKEN"]').attr('content'));
      }
    },
  });

  // Update global CSRF token if returned in response
  $(document).ajaxComplete(function (event, xhr, settings) {
    let newCsrfToken = xhr.getResponseHeader('X-CSRF-TOKEN');
    let tokenToSet = null;

    if (newCsrfToken) {
      tokenToSet = newCsrfToken;
    } else if (xhr.responseJSON && xhr.responseJSON.csrf_token) {
      tokenToSet = xhr.responseJSON.csrf_token;
    }

    if (tokenToSet) {
      $('meta[name="X-CSRF-TOKEN"]').attr('content', tokenToSet);
      $('input[name="csrf_test_name"]').val(tokenToSet); // Update all form inputs
    }
  });

  // 4. Global DataTables Defaults
  if ($.fn.dataTable) {
    console.log('[App] Setting DataTables global defaults');
    $.extend(true, $.fn.dataTable.defaults, {
      pageLength: 50,
      autoWidth: false,
      scrollX: true,
      dom:
        "<'row mb-2'<'col-sm-12'i>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row mt-4'<'col-sm-12 col-md-5 d-flex align-items-center dt-info-sm'><'col-sm-12 col-md-7 d-flex justify-content-end'p>>",
      language: {
        search: 'Cari:',
        lengthMenu: '_MENU_',
        info: "<span class='text-muted fw-medium'>Menampilkan <b class='text-dark'>_START_-_END_</b> dari <b class='text-dark'>_TOTAL_</b></span>",
        infoEmpty: "<span class='text-muted'>Menampilkan 0 data</span>",
        infoFiltered: "<span class='text-muted'>(disaring dari _MAX_ data)</span>",
        emptyTable:
          "<div class='text-center py-4 text-muted'><i class='bi bi-inbox fs-4 d-block mb-2'></i>Tidak ada data tersedia</div>",
        zeroRecords:
          "<div class='text-center py-4 text-muted'><i class='bi bi-search fs-4 d-block mb-2'></i>Pencarian tidak ditemukan</div>",
        paginate: {
          previous: 'Sebelumnya',
          next: 'Berikutnya',
        },
        processing:
          '<div class="dt-loader-container"><div class="dt-loader-spinner"><div class="spinner-border text-primary" role="status"></div></div><div class="dt-loader-text">Memuat Data...</div></div>',
      },
    });
  }

  // Handle session timeout or unauthorized AJAX
  $(document).ajaxError(function (event, xhr, settings, thrownError) {
    if (xhr.status === 401 || xhr.status === 403) {
      Swal.fire({
        icon: 'warning',
        title: 'Sesi Berakhir',
        text: 'Silakan login kembali untuk melanjutkan.',
        confirmButtonText: 'Login',
      }).then(() => {
        window.location.reload();
      });
    }
  });

  // Re-init components on any Bootstrap modal shown
  $(document).on('shown.bs.modal', function (e) {
    initCascadingSelectFormTambah(e.target);
    initGlobalSelect2(e.target);
  });

  // Dismiss preloader when DOM is ready (faster and more robust than waiting for all images/tiles)
  function dismissPreloader() {
    const preloader = document.getElementById('app-preloader');
    if (preloader) {
      preloader.style.opacity = '0';
      preloader.style.visibility = 'hidden';
      preloader.style.pointerEvents = 'none';
      setTimeout(() => {
        if (preloader.parentNode) {
          preloader.parentNode.removeChild(preloader);
        }
      }, 400);
    }
  }
  dismissPreloader();
});

// Global Tooltips Initialization
function initGlobalTooltips() {
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });
}

// Theme Toggle Logic
function initThemeToggle() {
  const $toggleBtn = $('.theme-toggle');
  const $iconDark = $('.theme-icon-dark');
  const $iconLight = $('.theme-icon-light');

  function setTheme(theme) {
    document.documentElement.setAttribute('data-bs-theme', theme);
    localStorage.setItem('theme', theme);

    if (theme === 'dark') {
      $iconDark.addClass('d-none');
      $iconLight.removeClass('d-none');
      // Optional: apply dark class to body if admin-lte specifically needs it for custom overrides
      $('body').addClass('dark-mode').removeClass('light-mode');
    } else {
      $iconLight.addClass('d-none');
      $iconDark.removeClass('d-none');
      $('body').addClass('light-mode').removeClass('dark-mode');
    }
  }

  // Initialize from local storage or system preference
  const savedTheme = localStorage.getItem('theme');
  if (savedTheme) {
    setTheme(savedTheme);
  } else {
    const prefersDark =
      window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    setTheme(prefersDark ? 'dark' : 'light');
  }

  $toggleBtn.on('click', function (e) {
    e.preventDefault();
    const currentTheme = document.documentElement.getAttribute('data-bs-theme');
    setTheme(currentTheme === 'dark' ? 'light' : 'dark');
  });
}

window.forceCacheBust = Date.now();
